import React from "react";
import styled from "styled-components";
import { gridStyles } from "../style";

const ANIMATION_DUR = 600;
const COL_DELAY = 25;

type Props = {
  isVisible: boolean;
  count: number;
};

const Guides: React.FC<Props> = ({ count, isVisible }) => {
  const cols = Array.from(Array(count).keys());

  return (
    <Root>
      {cols.map((c: any, i: number) => (
        <Guide key={i} delay={i * COL_DELAY} isVisible={isVisible} />
      ))}
    </Root>
  );
};

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  ${gridStyles}
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  grid-template-rows: 1fr;
  margin: auto;
  height: 100%;
  min-height: 100vh;
  max-width: var(--max-width);
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
`;

const Guide = styled.div<{ delay: number; isVisible: boolean }>`
  position: relative;

  ::before,
  ::after {
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    background-color: var(--bg-grid-line);
    top: 0;
    width: 1px;
    transition: transform ${ANIMATION_DUR}ms;
    transition-delay: ${(p) => p.delay}ms;
  }

  ::before {
    left: 0;
    transform: translateY(${(p) => (p.isVisible ? "0" : "100%")});
  }

  ::after {
    right: 0;
    transform: translateY(${(p) => (p.isVisible ? "0" : "-100%")});
  }
`;

export default Guides;
